import { render, staticRenderFns } from "./ModalRedirecionamento.vue?vue&type=template&id=18c3f1ce&lang=html"
import script from "./ModalRedirecionamento.vue?vue&type=script&lang=js"
export * from "./ModalRedirecionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports